module.exports = __webpack_public_path__ + "img/mc1_logo_light.65d5f40f.svg";